<script setup>
import Icon from '@/components/shared/icons/Icon.vue'
import {toRefs, computed} from 'vue'

const emit = defineEmits([
  'sort',
])
const props = defineProps({
  prop: {
    type: String,
    required: true,
  },
  currentSort: {
    type: String,
    default: '',
  },
  defaultDirection: {
    type: String,
    default: '',
  },
})

//Refs
const {currentSort, prop, defaultDirection} = toRefs(props)

//Computed props
const isActive = computed(() => currentSort.value.replace(/^-/, '') === prop.value)
const isDesc = computed(() => currentSort.value.match(/^-/))

// Generate accessible label for sort button
const sortLabel = computed(() => {
  const direction = isDesc.value ? 'descending' : 'ascending'
  return `Sort by ${prop.value}, ${direction}`
})

//Get direction
const getDir = () => {
  if (!isActive.value) {
    return defaultDirection.value
  }
  return isDesc.value ? '' : '-'
}

//Toggle
const toggle = () => {
  const dir = getDir()
  const sort = prop.value
    .split(',')
    .map(prop => `${dir}${prop}`)
    .join(',')

  //Emit event
  emit('sort', {sort})
}
</script>

<template>
  <span
    :class="$style.sort"
    :test-id="`tableSort-${prop}`"
    :aria-label="sortLabel"
    @click="toggle()"
  >
    <span>
      <slot />
    </span>
    <Icon
      v-if="isActive"
      icon="keyboard_arrow_up"
      size="s"
      :class="{
        [$style.icon]: true,
        [$style.desc]: isDesc,
      }"
    />
  </span>
</template>

<style module lang="scss">
.sort {
  cursor: pointer;
  display: flex;
  white-space: normal;
  align-items: center;
}
.icon {
  transition: transform var(--transition-ease);
  &.desc {
    transform: rotate(180deg);
  }
}
</style>
